/**
 * Converts Contentful's "Image" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import Image from 'components/Image'
import Typography from 'components/theme/Typography'
import { convertRichTextToComponent } from '../utils'

const ContentfulImage = ({
  src, alt, description, align, maxHeight, maxWidth, className,
}) => (
  <Image
    className={className}
    src={src?.file?.url}
    align={align}
    alt={alt}
    maxHeight={maxHeight}
    maxWidth={maxWidth}>
    <Typography variant="body1" className="mt-md">
      {convertRichTextToComponent(description)}
    </Typography>
  </Image>
)

ContentfulImage.propTypes = {
  src: PropTypes.object,
  alt: PropTypes.string,
  description: PropTypes.object,
  align: PropTypes.string,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

export default ContentfulImage
